export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7746.2150c1a2.jpg";